<div *ngFor="let alert of alerts.alerts">
  <alert (onClosed)="alerts.removeAlert(alert)" [dismissible]="alert.dismissible" [type]="alert.type">
    <span [innerHtml]="'<strong>' + alert.type.toUpperCase() + '</strong> ' + alert.text"></span>
  </alert>
</div>
<div
  *ngIf="popUpGCPActivated"
  [class.d-none]="!showGCPAnnouncements"
  class="position-fixed overflow-auto bg-light p-5 rounded shadow announcements"
>
  <div>
    <div class="d-flex flex-row justify-content-between align-items-start">
      <h2 class="h2 text-center">Announcements</h2>
      <button tooltip="Close" class="btn clickable m-1" (click)="showGCPAnnouncements = false">
        <app-vficon size="20px" iconPack="source-system-icons" iconName="close"></app-vficon>
      </button>
    </div>
    <ng-container *ngFor="let a of announcements">
      <div style="font-size: 1.2rem" class="custom-card p-4 overflow-auto mb-3" [innerHTML]="a"></div>
    </ng-container>
  </div>
</div>
<div
  [class.d-none]="!showAI"
  *ngIf="popUpAIActivated && !isLLMPage"
  class="position-fixed overflow-auto bg-light px-5 pb-5 rounded shadow ai-container"
>
  <app-llm (closeLLM)="showAI = false" [sidebar]="true"></app-llm>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <nav class="navbar navbar-expand-md navbar-white bg-white">
        <a class="navbar-brand d-md-none p-2 m-0" routerLink="/">
          <svg
            style="width: 4rem; display: inline-block"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 311.81 311.81"
          >
            <g data-name="<Group>">
              <circle data-name="<Path>" fill="#e60000" cx="155.91" cy="155.91" r="155.91"></circle>
              <path
                data-name="<Path>"
                fill="#fff"
                d="M157.13 242.31c-42.57.14-86.87-36.19-87.06-94.54C69.95 109.18 90.76 72 117.37 50c26-21.49 61.51-35.28 93.76-35.39 4.15 0 8.49.33 11.15 1.23-28.2 5.85-50.64 32.09-50.54 61.86a16.16 16.16 0 00.19 2.52c47.18 11.49 68.6 40 68.73 79.35s-30.97 82.56-83.53 82.74z"
              ></path>
            </g>
          </svg>
        </a>
        <button (click)="isExpanded = !isExpanded" class="navbar-toggler" type="button">
          <span class="navbar-toggler-icon text-dark nav-icon-span">
            <fa-icon class="fa-icon-position" [icon]="faBars"></fa-icon>
          </span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav list-unstyled">
            <li class="nav-item d-none d-md-block mx-2">
              <a class="navbar-brand p-2 m-0" routerLink="/">
                <svg
                  style="width: 4rem"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 311.81 311.81"
                >
                  <g data-name="<Group>">
                    <circle data-name="<Path>" fill="#e60000" cx="155.91" cy="155.91" r="155.91"></circle>
                    <path
                      data-name="<Path>"
                      fill="#fff"
                      d="M157.13 242.31c-42.57.14-86.87-36.19-87.06-94.54C69.95 109.18 90.76 72 117.37 50c26-21.49 61.51-35.28 93.76-35.39 4.15 0 8.49.33 11.15 1.23-28.2 5.85-50.64 32.09-50.54 61.86a16.16 16.16 0 00.19 2.52c47.18 11.49 68.6 40 68.73 79.35s-30.97 82.56-83.53 82.74z"
                    ></path>
                  </g>
                </svg>
              </a>
            </li>
            <ng-container *ngFor="let navItem of navBarItems">
              <li
                [ngClass]="{ 'd-none': !isExpanded, 'd-md-block': !isExpanded }"
                [class.disabled]="navItem.isDisabled"
                *ngIf="navItem.isInvisible !== true"
                class="nav-item active"
              >
                <a
                  [href]="navItem.href"
                  target="_blank"
                  class="nav-link mx-2 header-links"
                  container="body"
                  [class.disabled]="navItem.isDisabled"
                  [tooltip]="navItem.tooltip"
                  placement="left"
                >
                  {{ navItem.innerHTML }}
                </a>
                <span></span>
              </li>
            </ng-container>
          </ul>
          <div class="dropdown-list">
            <div id="tenant-dropdown" class="d-none d-md-block nav-item m-auto" *ngIf="allowedTenants.length > 1">
              <select
                tooltip="Switch between tenants"
                placement="left"
                [ngModel]="currentTenant"
                (change)="switchTenant($event.target.value)"
              >
                <option *ngFor="let t of allowedTenants" [value]="t">{{ t || "???" | prettifyAttribute }}</option>
              </select>
            </div>
            <div class="nav-item dropleft d-sm-block">
              <button
                tooltip="GCP New Announcements"
                class="nav-link btn popup-ai-btn pr-1"
                [class.d-none]="!isGCPPage"
                (click)="showGCPAnnouncements = !showGCPAnnouncements"
              >
                <div class="notification-wrapper">
                  <app-vficon
                    iconPack="source-mid-render-light-icons"
                    iconName="notification"
                    class="vficon-position"
                  ></app-vficon>
                  <span *ngIf="notificationCount > 0" class="notification-badge">
                    {{ notificationCount }}
                  </span>
                </div>
              </button>
            </div>
            <div
              id="admin-dropdown"
              class="nav-item dropdown d-none d-sm-block"
              *ngIf="user.permissions.isPcs || user.permissions.isCce || user.permissions.isBrm"
            >
              <button
                class="text-dark nav-link dropdown-toggle pr-1 btn"
                placement="left"
                container="body"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                tooltip="You are either from PCS or BRM"
              >
                <app-vficon
                  size="23px"
                  iconPack="source-mid-render-light-icons"
                  class="mx-1 vficon-position"
                  iconName="settings"
                ></app-vficon>
              </button>
              <div class="dropdown-menu">
                <ng-container *ngIf="user.permissions.isPcs || user.permissions.isCce">
                  <a class="dropdown-item" routerLink="/api-users" [class.active]="pathname === '/api-users'">
                    <span> API Users </span>
                    <app-vficon
                      size="15px"
                      class="float-right"
                      iconName="users"
                      iconPack="source-system-icons"
                    ></app-vficon>
                  </a>
                  <div class="dropdown-divider"></div>
                </ng-container>
                <a
                  class="dropdown-item"
                  routerLink="/service-metrics"
                  *ngIf="user.permissions.canSeeServiceMetrics"
                  [class.active]="pathname === '/service-metrics'"
                  placement="left"
                  tooltip="See metrics related to PCS services e.g. how many people signed in into the PCS Portal in the last 3 months"
                >
                  <span> Service Metrics </span>
                  <app-vficon
                    size="15px"
                    class="float-right"
                    iconName="chart-line"
                    iconPack="source-system-icons"
                  ></app-vficon>
                </a>
                <a
                  class="dropdown-item"
                  routerLink="/service-usage"
                  *ngIf="user.permissions.canSeeServiceFacts"
                  [class.active]="pathname === '/service-usage'"
                  [queryParams]="{ csp: 'aws' }"
                  placement="left"
                  tooltip="See information on usage of PCS services e.g. how many people are subscribed to auto-remediation"
                >
                  <span> Service Facts </span>
                  <app-vficon
                    size="15px"
                    class="float-right"
                    iconName="document"
                    iconPack="source-system-icons"
                  ></app-vficon>
                </a>
                <ng-container *ngIf="user.permissions.canSeeApiUsage">
                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    [queryParams]="{
                      Api: 'aws-v2',
                      StartTime: startTime,
                      EndTime: endTime,
                    }"
                    [class.active]="pathname === '/api-usage'"
                    placement="left"
                    tooltip="View stats on consumption of APIs over time"
                    routerLink="/api-usage"
                  >
                    <span> API Usage </span>
                    <app-vficon
                      size="15px"
                      class="float-right"
                      iconName="chart-bar"
                      iconPack="source-system-icons"
                    ></app-vficon>
                  </a>
                  <a
                    class="dropdown-item"
                    placement="left"
                    [queryParams]="{ StartTime: startTime, EndTime: endTime }"
                    [class.active]="pathname === '/global-api-usage'"
                    routerLink="/global-api-usage"
                    tooltip="See aggregated API usage between services in a heat map"
                  >
                    <span> Global API Usage </span>
                    <app-vficon
                      size="15px"
                      class="float-right"
                      iconName="international"
                      iconPack="source-system-icons"
                    ></app-vficon>
                  </a>
                </ng-container>
                <ng-container *ngIf="user.permissions.isPcs">
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" target="_blank" href="/pcms-utilities/index.html">
                    <span> PCS OPS Portal </span>
                    <app-vficon
                      size="15px"
                      class="float-right"
                      iconName="online"
                      iconPack="source-system-icons"
                    ></app-vficon>
                  </a>
                </ng-container>
                <ng-container *ngIf="!environment.production">
                  <div class="dropdown-divider"></div>
                  <span (click)="$event.stopPropagation()" class="dropdown-item font-weight-bold">
                    <span> Feature Toggles </span>
                    <app-vficon
                      size="15px"
                      class="float-right"
                      iconName="toggle"
                      iconPack="source-system-icons"
                    ></app-vficon>
                  </span>
                  <button
                    (click)="$event.stopPropagation(); environment.featureToggles[ft] = !environment.featureToggles[ft]"
                    *ngFor="let ft of Object.keys(environment.featureToggles)"
                    class="dropdown-item"
                  >
                    <span class="w-100 d-flex justify-content-between flex-row">
                      <span class="mr-3">{{ ft }}</span>
                      <input type="checkbox" [(ngModel)]="environment.featureToggles[ft]" />
                    </span>
                  </button>
                </ng-container>
              </div>
            </div>

            <div class="nav-item dropleft d-none d-sm-block">
              <button
                class="text-dark nav-link dropdown-toggle btn"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <app-vficon
                  size="23px"
                  iconPack="source-mid-render-light-icons"
                  class="mx-1 vficon-position"
                  iconName="signed-in"
                ></app-vficon>
              </button>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item disabled">
                  {{ email }}
                </a>
                <ng-container *ngIf="lastSignIn">
                  <a class="dropdown-item disabled">
                    Last Sign In:
                    {{ lastSignIn.epoch_datetime | date : "long" }}
                  </a>
                  <div class="dropdown-divider"></div>
                </ng-container>
                <ng-container *ngIf="!environment.production">
                  <a class="dropdown-item disabled"
                    >Total Cost:
                    {{
                      eventsService.currency.value.format.format(
                        eventsService.currency.value.exchangeRate
                          .mul(vcs.getTotalQueryCost("all", undefined))
                          .toDecimalPlaces(2)
                          .toNumber()
                      )
                    }}
                  </a>
                  <a class="dropdown-item disabled"
                    >Total LLM Cost:
                    {{
                      eventsService.currency.value.format.format(
                        eventsService.currency.value.exchangeRate
                          .mul(vcs.getTotalQueryCost("llm", undefined))
                          .toDecimalPlaces(2)
                          .toNumber()
                      )
                    }}
                  </a>
                  <a class="dropdown-item disabled"
                    >Total BQ, API GW & Cloud Run Cost:
                    {{
                      eventsService.currency.value.format.format(
                        eventsService.currency.value.exchangeRate
                          .mul(vcs.getTotalQueryCost("bq", undefined))
                          .toDecimalPlaces(2)
                          .toNumber()
                      )
                    }}</a
                  >
                  <a class="dropdown-item disabled">Total #Queries: {{ vcs.getTotalQueryCount() }}</a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item disabled"
                    >This Report BigQuery Cost:
                    {{
                      eventsService.currency.value.format.format(
                        eventsService.currency.value.exchangeRate
                          .mul(vcs.getTotalQueryCost("bq", location.pathname))
                          .toDecimalPlaces(2)
                          .toNumber()
                      )
                    }}</a
                  >
                  <a class="dropdown-item disabled">#Queries on this Report: {{ vcs.getThisReportQueries() }}</a>
                  <div class="dropdown-divider"></div>
                </ng-container>
                <a class="dropdown-item disabled">Color Scheme</a>
                <button
                  *ngFor="let s of tenant.availableColorSchemes"
                  (click)="
                    tenant.customiseColorScheme(s); localStorage.setItem('colorScheme', s); window.location.reload()
                  "
                  class="dropdown-item"
                  [class.disabled]="tenant.colorScheme === s"
                >
                  <span style="text-decoration: {{ tenant.colorScheme === s ? 'underline' : 'none' }}">{{ s }}</span>
                </button>
                <div class="dropdown-divider"></div>
                <a target="_blank" class="dropdown-item" href="https://confluence.sp.vodafone.com/x/ixNyEg">
                  <span> Help </span>
                  <app-vficon
                    size="15px"
                    class="float-right"
                    iconName="info-circle"
                    iconPack="source-system-icons"
                  ></app-vficon>
                </a>
                <a
                  *ngIf="user.permissions.canCreateCredentials || user.permissions.canReadAnyCredentials"
                  [class.active]="pathname === '/api-credentials'"
                  tooltip="View, delete and generate OAuth2 clients for access to APIs"
                  class="dropdown-item"
                  routerLink="/api-credentials"
                >
                  <span> API Credentials </span>
                  <app-vficon
                    size="15px"
                    class="float-right"
                    iconName="password-key"
                    iconPack="source-system-icons"
                  ></app-vficon>
                </a>
                <a
                  [class.active]="pathname === '/user'"
                  tooltip="See the tenancies you are in along with your permissions"
                  class="dropdown-item"
                  routerLink="/user"
                >
                  <span> User Info </span>
                  <app-vficon
                    size="15px"
                    class="float-right"
                    iconName="admin"
                    iconPack="source-system-icons"
                  ></app-vficon>
                </a>
                <div class="dropdown-divider"></div>
                <button class="btn dropdown-item" (click)="logout()">
                  <span> Log out </span>
                  <app-vficon
                    size="15px"
                    class="float-right"
                    iconName="chevron-right"
                    iconPack="source-system-icons"
                  ></app-vficon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</div>
